import { render } from "./MDBPopover.vue?vue&type=template&id=d6d18c44"
import script from "./MDBPopover.vue?vue&type=script&lang=js"
export * from "./MDBPopover.vue?vue&type=script&lang=js"

import exportComponent from "/home/mdb/projects/mdb5-repos/vue/build-tool/dev/mdb-vue-dev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__